import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-comp-bsaccordion',
	templateUrl:'./BSAccordionPage.html',
	styles: [],
	styleUrls:['./BSAccordionPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class BSAccordionPage
{
	mdContent_54 = `\`\`\`java
import com.jwebmp.plugins.bootstrap.accordion.BSAccordion;
\`\`\``;
	mdContent_55 = `\`\`\`java
new BSAccordion<>()
\`\`\``;
	mdContent_56 = `\`\`\`java
var accordion = new BSAccordion<>();
accordion.setCloseOthers(true);

var item1 = new BSAccordionItem<>();
item1.addHeader(new BSAccordionPanelHeader<>().setText("Section 1"));
item1.addContent(new BSAccordionPanelContent<>().setText("Content 1"));
item1.setActive(true);

var item2 = new BSAccordionItem<>();
item2.addHeader(new BSAccordionPanelHeader<>().setText("Section 2"));
item2.addContent(new BSAccordionPanelContent<>().setText("Content 2"));

accordion.addItem(item1);
accordion.addItem(item2);
\`\`\``;
}
